import { render, staticRenderFns } from "./PropriedadeModal.vue?vue&type=template&id=314a60d8&scoped=true"
import script from "./PropriedadeModal.vue?vue&type=script&lang=js"
export * from "./PropriedadeModal.vue?vue&type=script&lang=js"
import style0 from "./PropriedadeModal.vue?vue&type=style&index=0&id=314a60d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314a60d8",
  null
  
)

export default component.exports